import { render } from "./new_completed.vue?vue&type=template&id=2a4b4bbe"
import script from "./new_completed.vue?vue&type=script&lang=js"
export * from "./new_completed.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__